import { render, staticRenderFns } from "./BannerOrPlaceholder.vue?vue&type=template&id=32d4ff84&scoped=true&lang=pug"
import script from "./BannerOrPlaceholder.vue?vue&type=script&lang=js"
export * from "./BannerOrPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./BannerOrPlaceholder.vue?vue&type=style&index=0&id=32d4ff84&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4ff84",
  null
  
)

export default component.exports